import { render, staticRenderFns } from "./RowSelectionRegion.vue?vue&type=template&id=5bfbdbf4&scoped=true&lang=pug"
import script from "./RowSelectionRegion.vue?vue&type=script&lang=ts"
export * from "./RowSelectionRegion.vue?vue&type=script&lang=ts"
import style0 from "./RowSelectionRegion.vue?vue&type=style&index=0&id=5bfbdbf4&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfbdbf4",
  null
  
)

export default component.exports